<!-- 侧边栏 -->
<template>
    <div class="asideBar_box">
        <div class="problem_item phone_item">
            <div class="item">
                <i class="icon"></i>
                <p>电话咨询</p>
            </div>
            <div class="hide_phone">
                <h4>客服电话</h4>
                <p>400-617-1118</p>
            </div>
        </div>
        <div class="problem_item wx_item">
            <div class="item">
                <i class="icon"></i>
                <p>公众号</p>
            </div>
            <div class="hide_wx">
                <img src="@/assets/image/asideBar/asideQrcode.jpg" alt="" />
            </div>
        </div>
        <div class="problem_item prb_item">
            <div class="item" @click="toPrbtn">
                <i class="icon"></i>
                <p>意见反馈</p>
            </div>
        </div>
        <div class="problem_item topping_item">
            <div class="item" @click="toTop">
                <i class="icon"></i>
                <p>置顶</p>
            </div>
        </div>
        <!-- <qff-dialog :showDialog.sync="tipsShow" :title="'提示'" :closeBtn="'关闭'" :sureBtn="'登录'" @makeSure="toLogin">
            <div class="dialog-container">检测到您当前尚未登录企服福平台，请登陆后再进行问题反馈。</div>
        </qff-dialog> -->
        <message-dialog :showDialog.sync="tipsShow" :title="'提示'" :closeBtn="'关闭'" :sureBtn="'登录'" :pl="'0px'" @makeSure="toLogin">
            <div class="dialog-container">检测到您当前尚未登录企服福平台，请登录后再进行问题反馈。</div>
        </message-dialog>
    </div>
</template>
<script>
import qffDialog from '@/components/qffDialog.vue'
import messageDialog from '@/components/messageDialog.vue'
export default {
  components: {
    qffDialog,
    messageDialog,
  },
  data() {
    return {
      tipsShow: false,
      currentPath: '',
    }
  },
  //监听属性 类似于data概念
  computed: {
    token() {
      return window.localStorage.getItem('token')
    },
  },
  methods: {
    // 跳转问题反馈页
    toPrbtn() {
      if (!this.token) {
        this.tipsShow = true
        return false
      }

      if (this.currentPath == '/problem/feedBack') {
        return false
      }

      let routeData = this.$router.resolve({ path: '/problem/feedBack' })
      window.open(routeData.href, '_blank')
    },
    // 跳转登录页
    toLogin() {
      this.$router.push('/login')
    },
    // 返回顶部
    toTop() {
      let timer = setInterval(function () {
        //获取滚动条的滚动高度
        var scrollTop = document.documentElement.scrollTop || document.body.scrollTop
        //用于设置速度差，产生缓动的效果
        var speed = Math.floor(-scrollTop / 4)
        document.documentElement.scrollTop = document.body.scrollTop = scrollTop + speed //用纯数字赋值
        if (scrollTop === 0) {
          clearInterval(timer)
        }
      }, 30)
    },
  },
  created() {
    this.currentPath = this.$route.path
  },
}
</script>
<style scoped lang="scss">
.asideBar_box {
  position: fixed;
  right: 30px;
  top: 55%;
  z-index: 999;

  width: 68px;
  height: 308px;
  text-align: left;

  .problem_item {
    position: relative;

    width: 68px;
    height: 68px;
    margin-bottom: 12px;
    background: linear-gradient(180deg, #fffdfd 7%, #ffffff 100%);
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1);
    border-radius: 6px 6px 6px 6px;

    &:nth-last-child(1) {
      margin-bottom: 0;
    }

    .item {
      position: absolute;
      top: 0;
      left: 0;

      width: 100%;
      height: 100%;
      text-align: center;
      cursor: pointer;

      &:hover {
        p {
          color: #be1a21;
        }
      }

      .icon {
        display: block;
        margin: 9px auto 5px;
        width: 28px;
        height: 28px;
      }

      p {
        height: 17px;
        font-size: 12px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #767676;
        line-height: 17px;
      }
    }
  }

  .phone_item {
    .item {
      .icon {
        background: url('@/assets/image/problem/asideIcon_grey01.png');
      }
    }
    &:hover {
      .hide_phone {
        display: block;
      }

      .item {
        .icon {
          background: url('@/assets/image/problem/asideIcon_red01.png');
        }
      }
    }

    .hide_phone {
      display: none;
      position: absolute;
      left: -224px;
      top: 0;
      bottom: 0;
      margin: auto;

      width: 210px;
      height: 68px;
      padding: 9px 0 0 39px;
      background: #ffffff;
      border-radius: 6px 6px 6px 6px;
      box-sizing: border-box;

      h4 {
        height: 28px;
        font-size: 14px;
        font-weight: 400;
        color: #767676;
        line-height: 28px;
      }

      p {
        margin-top: -3px;
        height: 22px;
        font-size: 16px;
        font-family: Alibaba PuHuiTi 2-75 SemiBold, Alibaba PuHuiTi 20;
        font-weight: 600;
        color: #1a1a1a;
        line-height: 22px;
      }
    }
  }

  .wx_item {
    .item {
      .icon {
        background: url('@/assets/image/problem/asideIcon_grey02.png');
      }
    }
    &:hover {
      .item {
        .icon {
          background: url('@/assets/image/problem/asideIcon_red02.png');
        }
      }

      .hide_wx {
        display: block;
      }
    }

    .hide_wx {
      display: none;
      position: absolute;
      left: -234px;
      top: 0;
      bottom: 0;
      margin: auto;

      width: 210px;
      height: 210px;
      background: #ffffff;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .prb_item {
    .item {
      .icon {
        background: url('@/assets/image/problem/asideIcon_grey03.png');
      }
    }
    &:hover {
      .item {
        .icon {
          background: url('@/assets/image/problem/asideIcon_red03.png');
        }
      }
    }
  }

  .topping_item {
    .item {
      .icon {
        width: 30px;
        height: 30px;
        background: url('@/assets/image/problem/asideIcon_grey04.png');
      }
    }
    &:hover {
      .item {
        .icon {
          background: url('@/assets/image/problem/asideIcon_red04.png');
        }
      }
    }
  }
}
</style>
